export default __webpack_public_path__ + "static/media/partner5.ed40c404.jpg";